<template>
<div class="chapter">
<div class="inner_page">
<a id="VPS-3"></a>
<h1 class="title1">Helping Stop Hitler’s Luftwaffe</h1>
<p class="title2">The Memoirs of a Pilot Involved in the Development of Radar Interception, Vital in the Battle of Britain</p>
<h2 class="author">Air Marshal Sir Arthur McDonald</h2>
<p class="author2">KCB AFC FRAes DL</p>
<div class="img_container1"><img alt="image" class="wid" src="images/Img_3_001.jpg"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?54ecbc54